import React from 'react';
import {
  Row,
  Col,
  DatePicker,
  Typography,
  Skeleton,
  Result
} from 'antd'
// import {
//   SearchOutlined
// } from '@ant-design/icons';
// import {
//   useLocation,
//   useNavigate,
// } from 'react-router-dom';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';
// import DashboardCard from './components/DashboardCard';
import DashboardBarchart from './components/DashboardBarchart';
import DashboardInfo from './components/DashboardInfo';
import SimpleDashboardCard from './components/SimpleDashboardCard';
// import DashboardRevenueDoughnut from './components/DashboardRevenueDoughnut';

function Dashboard() {
  const location = useLocation();
  const redirect = useNavigate();
  const start_date = new URLSearchParams(location.search).get('start_date');
  const end_date = new URLSearchParams(location.search).get('end_date');

  const dashboardCardQuery = useQuery({
    queryKey: [`/api/dashboard/getDashboardCard?start_date=${start_date}&end_date=${end_date}`],
  })
  const amountQyuery = useQuery({
    queryKey: [`/api/dashboard/getAmountByDetails?start_date=${start_date}&end_date=${end_date}`],
  })
  const revenueQuery = useQuery({
    queryKey: [`/api/dashboard/getRevenue`],
  })


  if (
    dashboardCardQuery.isLoading
    || revenueQuery.isLoading
    || amountQyuery.isLoading
  ) {
    return <Skeleton active />
  }

  if (
    dashboardCardQuery.isError
    || revenueQuery.isError
    || amountQyuery.isError
  ) {
    return <Result
      status="error"
      title={
        dashboardCardQuery.error.message
        || revenueQuery.error.message
        || amountQyuery.error.message
      } />
  };

  const onSelectDate = (value, dateString) => {
    // console.log('Selected Time: ', value);
    // console.log('Formatted Selected Time: ', console.log(dayjs(dateString)));
    redirect(`/admin/dashboard?start_date=${dayjs(value[0]).toISOString()}&end_date=${dayjs(value[1]).toISOString()}`)
  };

  // console.log('amountQyuery.data = ', amountQyuery.data)
  // console.log('dashboardCardQuery.data = ', dashboardCardQuery.data)
  // console.log('revenueQuery.data = ', revenueQuery.data)
  // console.log('openCalendar = ', openCalendar)

  return (
    <div>
      <Row justify="space-between" style={{ marginBottom: '16px' }}>
        <Col>
          <Typography.Title level={5} style={{ margin: 0, padding: 0, color: '#483D8B' }}>
            {`${dayjs().format('DD MMM YYYY')},${dayjs().format('dddd')}`}
          </Typography.Title>
        </Col>
        <Col>
          <DatePicker.RangePicker
            allowClear={false}
            defaultValue={[dayjs(start_date), dayjs(end_date)]}
            onChange={onSelectDate}
          />
        </Col>
      </Row>
      <Row justify='space-between' gutter={[16, 16]}>
        <Col xs={24}>
          <Row gutter={[16, 16]} justify="space-between" >
            {amountQyuery.data.revenue.map(item => <Col xs={24} sm={12} md={8} key={item.label}>
              <SimpleDashboardCard cardData={item} />
            </Col>)}
          </Row>
        </Col>
        <Col xs={24}>
          <Row gutter={[16, 16]} justify="space-between" >
            {amountQyuery.data.student.map(item => <Col xs={24} sm={12} md={8} key={item.label}>
              <SimpleDashboardCard cardData={item} />
            </Col>)}
          </Row>
        </Col>


        <Col xs={24}>
          <DashboardBarchart revenue={revenueQuery.data} />
        </Col>
        <Col xs={24}>
          <DashboardInfo />
        </Col>
      </Row>

      {/* <Row style={{ marginBottom: '16px' }}>
        <Col>
          <div className='dashboard-rangepicker-container'>
            <DatePicker.RangePicker
              defaultValue={[dayjs(startDate), dayjs(endDate)]}
              format={'DD-MM-YYYY'}
              allowClear={false}
              onChange={onChange}
            />
          </div>
        </Col>
      </Row>
      <Row justify="space-between" gutter={[16, 16]} style={{ marginBottom: '32px' }}>
        {
          cardDatas.map(item =>
            <Col xs={24} sm={12} md={6} key={item.key}>
              <SalesCard cardTemplate={item} cardData={data} />
            </Col>
          )
        }
      </Row>
      <Row justify="space-between" gutter={[16, 16]}>
        <Col xs={24}>
          <DashboardBarchart barData={data.weekly_order} />
        </Col>
      </Row> */}
    </div>
  )
}

export default Dashboard